<script setup lang="ts">
import HeaderElement from '@/elements/Header/HeaderElement.vue'
import SideMenu from '@/elements/SideMenu/SideMenu.vue'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

const sidebarOpen = ref(false)

const route = useRoute()
</script>

<template>
  <div class="main-layout" v-if="route.name === 'addMachines' || route.name === 'landing'">
    <slot></slot>
  </div>
  <div v-else class="main-layout">
    <HeaderElement v-model:sidebar-open="sidebarOpen" />
    <SideMenu v-model:sidebar-open="sidebarOpen" />
    <main :class="{ 'sidebar-expanded': sidebarOpen }">
      <slot></slot>
    </main>
  </div>
</template>

<style lang="scss" scoped>
@use '@/style/media-queries.scss' as mq;

.main-layout {
  width: 100%;
  height: 100%;
}

main {
  width: 100%;
  height: 100%;
  padding-top: var(--ullib-size-header-height);
  padding-left: var(--ullib-size-sidebar-width-collapsed);
  transition: padding-left 0.3s ease-in-out;
  &.sidebar-expanded {
    padding-left: var(--ullib-size-sidebar-width-expanded);
  }
  overflow: hidden;
}

@include mq.lt-sm {
  main {
    padding-left: 0;
    &.sidebar-expanded {
      padding-left: 0;
    }
    overflow: hidden;
  }
}
</style>
